import request from '@/api/index';

export default function () {

}

export function getNewsPageList(params) {
  return request({
    url: '/vodas/getNewsPageList',
    method: 'GET',
    params: params
  });
}

export function getJobPageList(params) {
  return request({
    url: '/vodas/getJobPageList',
    method: 'GET',
    params: params
  });
}

export function getJobDetail(id) {
  return request({
    url: '/vodas/getNewsDetail/' + id,
    method: 'GET'
  });
}

export function captchaImage() {
  return request({
    url: '/captchaImage',
    method: 'GET'
  });
}

export function saveAgent(data) {
  return request({
    url: '/vodas/saveAgent',
    method: 'POST',
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/api.js